import { setBit } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { updateUserConfiguration } from 'owa-options-core';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Toggle folder pane expansion collapse state on user click on hamburger button
 * @param state the SetFolderPaneStateCollapsedAndNonDynamicBitState which contains user options
 */
export default action('setFolderPaneStateCollapsedAndNonDynamicBit')(select({
    viewStateConfiguration: function () { return getUserConfiguration().ViewStateConfiguration; },
})(function setFolderPaneStateCollapsedAndNonDynamicBit(isCollapsedAndNonDynamic, state) {
    // CTQ here?
    setBit(isCollapsedAndNonDynamic /* value */, 4 /* FolderPaneStateCollapsedAndNonDynamic */);
    updateUserConfiguration([
        {
            propertyName: 'ListViewBitFlags',
            propertyType: 'Integer32',
            propertyValue: "" + state.viewStateConfiguration.ListViewBitFlags,
        },
    ], 'OWA.ViewStateConfiguration');
}));
//# sourceMappingURL=setFolderPaneStateCollapsedAndNonDynamicBit.js.map